import { useMemo, useState } from "react";
import Workspace from "../services/common-components/Workspace";
import { formatNameToScopeId } from "../utils/util-id-parser";
import { appVersion } from "../version";

const SnippetRoute = () => {
  const queryParameters = useMemo(() => new URLSearchParams(window.location.search), []);
  const [isLoading, setIsLoading] = useState(true);

  const params = useMemo(() => {
    let organizationId =
      queryParameters.get("organization_id") || queryParameters.get("organizationId");
    organizationId = formatNameToScopeId(organizationId);
    let accountId = queryParameters.get("account_id") || queryParameters.get("accountId");
    accountId = formatNameToScopeId(accountId);
    let workspaceId =
      queryParameters.get("workspace_id") ||
      queryParameters.get("workspaceId") ||
      queryParameters.get("setup_id") ||
      queryParameters.get("setupId");
    workspaceId = formatNameToScopeId(workspaceId);

    return {
      token: queryParameters.get("token"),
      organizationId,
      accountId,
      workspaceId,

      accountName: queryParameters.get("account_name") || queryParameters.get("accountName"),
      workspaceName:
        queryParameters.get("workspace_name") ||
        queryParameters.get("workspaceName") ||
        queryParameters.get("setup_name") ||
        queryParameters.get("setupName"),
      agentName: queryParameters.get("agent_name") || queryParameters.get("agentName"),
      agentId: queryParameters.get("agent_id") || queryParameters.get("agentId") || "",
      channelId: queryParameters.get("channelId") || queryParameters.get("channel_id") || "",
      showActionButtons: queryParameters.get("show_action_buttons") === "true",
      canEditChannel: queryParameters.get("can_edit_channel") !== "false",
      agentLanguage:
        queryParameters.get("agent_language") || queryParameters.get("agentLanguage") || "en-US",
    };
  }, [queryParameters]);

  return (
    <div className="w-full flex flex-col">
      <Workspace {...params} isLoading={isLoading} setIsLoading={setIsLoading} />
      {!isLoading && <span className="pl-4 text-[10px] text-start">version: {appVersion}</span>}
    </div>
  );
};

export default SnippetRoute;
